export const ITEMS_PER_PAGE_OPTIONS: number[] = [50, 100, 250];
